import * as yup from 'yup';

export const Option = yup.object().shape({
  value: yup.string().required(),
});

export const OptionNulable = yup.object().shape({
  value: yup.string().nullable(),
});

export const schema = (
  tp: (key: string, params?: { [key: string]: string | number }) => string
) => {
  return yup.object().shape({
    species: OptionNulable,
    barn_ldc_nr: OptionNulable,
    animal_id: OptionNulable,
    status: yup.string().required(),
    date: yup.date().required(),
    status_pregnant: yup.string().nullable(),
    investigation_method: OptionNulable,
    number_of_fetuses: yup.mixed().when({
      is: (value) => !!String(value),
      then: yup.mixed().when('status_pregnant', {
        is: (value) => !!Number(value),
        then: yup
          .number()
          .min(1, tp('events.number_of_fetuses_error_comment_min'))
          .max(5, tp('events.number_of_fetuses_error_comment_max')),
        otherwise: yup.number().max(0, ''),
      }),
      otherwise: yup.mixed().nullable(),
    }),
    notes: yup.string().max(4000).nullable(),
    file: yup.mixed(),
  });
};
